import {createGlobalStyle} from "styled-components"

export const FlexStyles = createGlobalStyle`
  /* First we have a base flex class to apply to any input that we want to flexify and fill it's container */
  /* the idea is to then let the parent define width */

  .flex-override {
    display: flex;
    flex: 1;
    width: 100%;
    padding: unset;
    margin: unset;
  }

  /* Then we remove the adjustments made by the <Form> component, you'll need your component wrapped in a <Form> */

  .form-horizontal .flex-override,
  .flex-override .col-xs-12
  {
    padding: unset;
    margin: unset;
  }


  /* Next we have some component specifc overrides to remove the margin top. Note we keep the bottom margin to keep separation */
  /* between the component and error message */
  /* if in the future we rework these components, the errors should likely be separate from the component and positioned however */

  .flex-select-override #tag__select {
    margin-top: unset;
  }

  .flex-input-override .form-control {
    margin-top: unset;
  }

`
